import {
  useEffect, useState, useMemo, useCallback,
} from 'react';
import Cookies from 'js-cookie';

const getGeoLoc = () => {
  const location = Cookies.get('geoLocation');
  if (location) {
    const [region, state, address] = location.split(':');
    return { region, state, address };
  }
  return null;
};

export default function useLatLng(geolocateOnLoad) {
  const geoLoc = useMemo(() => getGeoLoc(), []);
  const [latlng, setLatlng] = useState(null);

  const mapsLatLng = useCallback((service) => {
    if (geoLoc) {
      service.geocode({
        region: geoLoc.region,
        address: geoLoc.address,
      }, (results) => {
        const { location } = results[0].geometry;
        setLatlng({
          lat: location.lat(),
          lng: location.lng(),
        });
      });
    }
  }, [geoLoc]);

  const getFromService = useCallback((provider) => {
    if (provider === 'google') mapsLatLng(new window.google.maps.Geocoder());
  }, [mapsLatLng]);

  const getLatLng = useCallback((provider) => () => {
    if (!latlng && geolocateOnLoad) {
      getFromService(provider);
      document.removeEventListener('mfe:googleMapsApiJsLoad', getLatLng);
    }
  }, [geolocateOnLoad, getFromService, latlng]);

  useEffect(() => {
    if (!latlng && geolocateOnLoad) {
      document.addEventListener('mfe:googleMapsApiJsLoad', getLatLng('google'));
    }
  }, [getLatLng, latlng, geolocateOnLoad]);

  return latlng;
}
